module.exports = __webpack_public_path__ + "static/media/ec.5d6fdbf8.svg";